import React, { Component } from 'react'
import { connect } from 'react-redux'
import { closeOrderPopUp } from '../action/hCommerce2'
import { popUpConfig } from '../JS/colorConfig'

class OrderSuccessPopUp extends Component {

    componentDidMount() {
        popUpConfig(this.props.menuColor);
        setTimeout(() => {
            this.closePopup();
        },2000)
    }
    closePopup = () => {
        this.props.closeOrderPopUp(false, null, null,false);
    }
    render() {
        return (
            <section class={`notice ${this.props.orderPopupError !== null ? this.props.orderPopupError ? "error" : "success" : ""}`} >
            <div class="notice-text">
                <p><strong dangerouslySetInnerHTML={{__html: `${this.props.orderPopUpMsg1 ? this.props.orderPopUpMsg1 : ""} ${this.props.orderPopUpMsg2 ? this.props.orderPopUpMsg2 : ""}`}}></strong></p>
                {/* <p>To see the status of your order, click on <strong>Notifications</strong> in the toolbar</p> */}
            </div>
             <div class="notice-icon">
             {this.props.orderPopUpMsg1 !== "Unlocking Door" ? this.props.orderPopupError ? <i class={`fas fa-times`}></i> : <i class={`fas fa-check-circle`}></i> : <i class={`fas fa-unlock`}></i>}
            </div>
           
        </section>
            /*<section class="my-orders open">
                <div class="orders-container">
                    <div class="orders-heading">
                        <h5>{this.props.orderPopUpMsg1}</h5>
                        <a onClick={this.closePopup} class="order-toggle"><i class="fas fa-lg fa-times"></i></a>
                    </div>
                    <form>
                        <div class="orders-body-container">
                            <div class="orders-body">
                                <p><strong>{this.props.orderPopUpMsg2}</strong></p>
                                 <p>To see the status of your order, click on the notifications in the tool bar.</p> 
                            </div>
                        </div>
                    </form>
                </div>
            </section>*/
        )
    }
}


const mapStateToProps = state => {
    return {
        orderPopUpMsg1: state.store2.orderPopUpMsg1,
        orderPopUpMsg2: state.store2.orderPopUpMsg2,
        orderPopupError: state.store2.orderPopupError,
        menuColor: state.store.home.MenuColor
    }
}

export default connect(
    mapStateToProps,
    {
        closeOrderPopUp
    }
)(OrderSuccessPopUp);